export const STOCK_SYNC_STATUS = {
    STARTED: 'started',
    SUCCESS: 'success',
    FAILED: 'failed',
    IDLE: 'idle',
} as const;

export type StockSyncStatus =
    (typeof STOCK_SYNC_STATUS)[keyof typeof STOCK_SYNC_STATUS];
